<!-- 介绍 -->
<template>
  <div class="frame">
    <div class="intro_hero">
      <div class="bg"></div>
      <div class="hero_mask"></div>
      <div class="hero_tabs">
        <button
          type="button"
          :class="{ hero_tab: true, active: activeTab === 0 }"
          @click="activeTab = 0"
        >
          {{ $t("message.intro.type1.company") }}
        </button>
        <button
          type="button"
          :class="{ hero_tab: true, active: activeTab === 1 }"
          @click="activeTab = 1"
        >
          {{ $t("message.intro.type2.company") }}
        </button>
      </div>
      <div class="hero_content">
        <div
          class="company_col company_col--primary"
          :class="{ 'is-mobile-active': activeTab === 0 }"
        >
          <div class="logo_wrap">
            <h2 class="hero_title">{{ $t("message.intro.type1.title") }}</h2>
            <div class="accent_line"></div>
          </div>
          <p class="desc">{{ $t("message.intro.type1.desc") }}</p>
        </div>
        <div class="divider"></div>
        <div
          class="company_col"
          :class="{ 'is-mobile-active': activeTab === 1 }"
        >
          <div class="logo_wrap">
            <img class="logo logo_sm" src="@/assets/intro2_logo_active.png" alt="" />
            <div class="logo_text">{{ $t("message.intro.type2.title") }}</div>
          </div>
          <p class="desc">{{ $t("message.intro.type2.desc") }}</p>
        </div>
      </div>
    </div>
    <div class="features">
      <div class="feature_item" v-for="item in features" :key="item.key">
        <div class="icon_wrap">
          <i :class="item.icon"></i>
        </div>
        <div class="feature_title">{{ $t(`message.intro.${item.key}.title`) }}</div>
        <div class="feature_desc">
          <p>{{ $t(`message.intro.${item.key}.desc1`) }}</p>
          <p>{{ $t(`message.intro.${item.key}.desc2`) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeTab: 0,
      features: [
        { key: "feature1", icon: "el-icon-s-home" },
        { key: "feature2", icon: "el-icon-medal" },
        { key: "feature3", icon: "el-icon-s-promotion" },
        { key: "feature4", icon: "el-icon-service" },
      ],
    };
  },
};
</script>
<style lang='scss' scoped>
.intro_hero {
  position: relative;
  color: #fff;

  .bg {
    width: 100%;
    min-height: 480px;
    background-image: url("../assets/intro_bg.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
  }

  .hero_mask {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
  }

  .hero_tabs {
    display: none;
  }

  .hero_content {
    position: absolute;
    inset: 0;
    max-width: 1200px;
    margin: 0 auto;
    padding: 48px 24px;
    display: flex;
    align-items: center;
    gap: 0;
    box-sizing: border-box;
  }

  .company_col {
    flex: 1;
    min-width: 0;
    padding: 0 24px;

    &--primary {
      .logo_wrap {
        margin-bottom: 20px;
      }

      .hero_title {
        margin: 0 0 16px;
        font-family: 思源黑体, "Microsoft YaHei", sans-serif;
        font-size: 30px;
        font-weight: 700;
        line-height: 1.5;
        color: #fff;
      }

      .accent_line {
        width: 48px;
        height: 3px;
        background-color: $theme;
      }

      .desc {
        max-width: 420px;
      }
    }

    .logo_wrap {
      margin-bottom: 24px;

      .logo {
        width: 220px;
        max-width: 100%;
        display: block;
        margin-bottom: 8px;
      }

      .logo_sm {
        width: 180px;
      }

      .logo_text {
        font-size: 13px;
        letter-spacing: 2px;
        opacity: 0.9;
      }
    }

    .desc {
      margin: 0;
      font-size: 14px;
      line-height: 2;
      text-align: justify;
      color: rgba(255, 255, 255, 0.95);
    }
  }

  .divider {
    width: 1px;
    align-self: stretch;
    background: rgba(255, 255, 255, 0.35);
    flex-shrink: 0;
    margin: 12px 0;
  }
}

.features {
  max-width: 1200px;
  margin: 0 auto;
  padding: 48px 24px 56px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  background: $page-bg;

  .feature_item {
    text-align: center;
    padding: 8px 12px;

    .icon_wrap {
      width: 48px;
      height: 48px;
      margin: 0 auto 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: $theme;
      font-size: 32px;
    }

    .feature_title {
      font-size: 16px;
      font-weight: 600;
      color: $text-dark;
      margin-bottom: 12px;
    }

    .feature_desc {
      p {
        margin: 0;
        font-size: 13px;
        line-height: 1.8;
        color: #777;
      }
    }
  }
}

@include respond-md {
  .intro_hero {
    min-height: auto;

    .bg {
      min-height: auto;
    }

    .hero_tabs {
      position: relative;
      z-index: 2;
      display: flex;
      margin: 0 auto;
      max-width: 1200px;
      padding: 16px 16px 0;
      gap: 8px;

      .hero_tab {
        flex: 1;
        height: 40px;
        border: 1px solid rgba(255, 255, 255, 0.45);
        background: rgba(255, 255, 255, 0.12);
        color: rgba(255, 255, 255, 0.85);
        font-size: 13px;
        cursor: pointer;
        transition: all 0.2s;

        &.active {
          background: $theme;
          border-color: $theme;
          color: #fff;
        }
      }
    }

    .hero_content {
      position: relative;
      inset: auto;
      flex-direction: column;
      padding: 20px 16px 28px;
      overflow: visible;
    }

    .divider {
      display: none;
    }

    .company_col {
      display: none;
      padding: 0;

      &.is-mobile-active {
        display: block;
      }

      &--primary {
        .hero_title {
          font-size: 22px;
          margin-bottom: 12px;
        }

        .accent_line {
          width: 40px;
          height: 2px;
        }

        .desc {
          max-width: none;
        }
      }

      .logo {
        width: 180px;
      }

      .logo_sm {
        width: 150px;
      }

      .desc {
        font-size: 13px;
        line-height: 1.85;
      }
    }
  }

  .features {
    grid-template-columns: repeat(2, 1fr);
    padding: 24px 12px 32px;
    gap: 12px;

    .feature_item {
      padding: 12px 8px;

      .icon_wrap {
        width: 40px;
        height: 40px;
        margin-bottom: 10px;
        font-size: 26px;
      }

      .feature_title {
        font-size: 14px;
        margin-bottom: 8px;
      }

      .feature_desc p {
        font-size: 12px;
        line-height: 1.6;
      }
    }
  }
}
</style>
